import { ModelWithAddressAndContactInfo } from './model-with-address-contact-info';
import { PeriziaUniversale } from './perizia-universale';

export class StimaDannoPeriziaUniversale extends ModelWithAddressAndContactInfo {
  static apiUrl: string = "stime_danno_perizia_universale";

  descrizione: string;
  importo: number;

  perizia_universale: PeriziaUniversale;

  deserialize(input: any): StimaDannoPeriziaUniversale {
    let retV: StimaDannoPeriziaUniversale = new StimaDannoPeriziaUniversale();

    retV = super.deserialize(input) as StimaDannoPeriziaUniversale;

    if (input?.perizia_universale) {
      retV.perizia_universale = new PeriziaUniversale().deserialize(input.perizia_universale);
    }


    return retV;
  }

}
